export default "__VITE_ASSET__DSZutrku__"